module.exports = __webpack_public_path__ + "static/img/pic_hy@2x.010b02d9.png";